import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Fab from '@mui/material/Fab';
import PagesIcon from '@mui/icons-material/Pages';
import Tooltip from '@mui/material/Tooltip';
import { getEndpoint } from '../config';

function CustomPages() {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editPage, setEditPage] = useState(null); // null or {id, ...}
  const [form, setForm] = useState({ section: '', meta_title: '', meta_description: '', meta_keywords: '', content: '' });
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPages();
  }, []);

  const fetchPages = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        toast.error('توکن احراز هویت یافت نشد. لطفاً دوباره وارد شوید.');
        window.location.href = '/login';
        return;
      }
      
      const res = await fetch(getEndpoint('CUSTOM_PAGES'), {
        headers: { 'Authorization': 'Bearer ' + token }
      });
      
      if (res.status === 401) {
        toast.error('توکن منقضی شده است. لطفاً دوباره وارد شوید.');
        localStorage.removeItem('token');
        window.location.href = '/login';
        return;
      } else if (res.status === 403) {
        toast.error('توکن نامعتبر است. لطفاً دوباره وارد شوید.');
        localStorage.removeItem('token');
        window.location.href = '/login';
        return;
      }
      
    const data = await res.json();
      setPages(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error fetching pages:', err);
      toast.error('خطا در دریافت صفحات');
      setPages([]);
    }
        setLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('آیا از حذف این صفحه مطمئن هستید؟')) return;
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${getEndpoint('CUSTOM_PAGES')}/${id}`, {
      method: 'DELETE',
        headers: { 'Authorization': 'Bearer ' + token }
    });
    if (res.ok) {
      fetchPages();
      toast.success('صفحه حذف شد.');
    } else {
        toast.error('خطا در حذف صفحه.');
      }
    } catch (err) {
      console.error('Error deleting page:', err);
      toast.error('خطا در حذف صفحه.');
    }
  };

  const handleOpenModal = (page = null) => {
    setEditPage(page);
    setForm(page ? {
      section: page.section || '',
      meta_title: page.meta_title || '',
      meta_description: page.meta_description || '',
      meta_keywords: page.meta_keywords || '',
      content: page.content || ''
    } : { section: '', meta_title: '', meta_description: '', meta_keywords: '', content: '' });
    setModalOpen(true);
  };

  const handleSave = async () => {
    if (!form.section || !form.meta_title) {
      toast.error('عنوان و آدرس الزامی است.');
      return;
    }
    setSaving(true);
    try {
      const token = localStorage.getItem('token');
    const method = editPage ? 'PUT' : 'POST';
              const url = editPage ? `${getEndpoint('CUSTOM_PAGES')}/${editPage.id}` : getEndpoint('CUSTOM_PAGES');
      
    const res = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify(form)
    });
    if (res.ok) {
      setModalOpen(false);
      fetchPages();
      toast.success(editPage ? 'صفحه ویرایش شد.' : 'صفحه افزوده شد.');
    } else {
        const errorData = await res.json();
        toast.error(errorData.error || 'خطا در ذخیره‌سازی صفحه.');
      }
    } catch (err) {
      console.error('Error saving page:', err);
      toast.error('خطا در ذخیره‌سازی صفحه.');
    }
    setSaving(false);
  };

  return (
    <Box sx={{ maxWidth: 900, mx: 'auto', mt: 4, direction: 'rtl' }}>
      <Typography variant="h5" sx={{ fontFamily: 'Vazir', fontWeight: 'bold', mb: 3 }}>مدیریت صفحات سفارشی</Typography>
      <Fab color="success" aria-label="add" onClick={() => handleOpenModal()}
        sx={{ position: 'fixed', bottom: 32, left: 32, zIndex: 1000, fontFamily: 'Vazir', fontWeight: 'bold' }}>
        <AddIcon />
      </Fab>
      <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{ fontFamily: 'Vazir', fontWeight: 'bold' }}>عنوان</TableCell>
              <TableCell align="center" sx={{ fontFamily: 'Vazir', fontWeight: 'bold' }}>آدرس</TableCell>
              <TableCell align="center" sx={{ fontFamily: 'Vazir', fontWeight: 'bold' }}>عملیات</TableCell>
              <TableCell align="center" sx={{ fontFamily: 'Vazir', fontWeight: 'bold' }}>صفحه‌ساز</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow><TableCell colSpan={3} align="center">در حال بارگذاری...</TableCell></TableRow>
            ) : pages?.length === 0 ? (
              <TableRow><TableCell colSpan={3} align="center">صفحه‌ای وجود ندارد.</TableCell></TableRow>
          ) : pages?.map(page => (
              <TableRow key={page.id}>
                <TableCell align="center" sx={{ fontFamily: 'Vazir' }}>{page.meta_title}</TableCell>
                <TableCell align="center" sx={{ fontFamily: 'Vazir' }}>{page.section}</TableCell>
                <TableCell align="center">
                  <IconButton color="primary" onClick={() => handleOpenModal(page)}><EditIcon /></IconButton>
                  <IconButton color="error" onClick={() => handleDelete(page.id)}><DeleteIcon /></IconButton>
                </TableCell>
                <TableCell align="center">
                  <Tooltip title="ویرایش با صفحه‌ساز">
                    <IconButton color="secondary" onClick={() => navigate(`/custom-pages/page-editor/${page.section}`)}>
                      <PagesIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)} maxWidth="sm" fullWidth PaperProps={{ sx: { direction: 'rtl', textAlign: 'right', fontFamily: 'Vazir' } }}>
        <DialogTitle sx={{ fontFamily: 'Vazir', fontWeight: 'bold', textAlign: 'right' }}>{editPage ? 'ویرایش صفحه' : 'افزودن صفحه جدید'}</DialogTitle>
        <DialogContent sx={{ direction: 'rtl', textAlign: 'right' }}>
          <TextField
            label="آدرس (section)"
            value={form.section}
            onChange={e => setForm(f => ({ ...f, section: e.target.value }))}
            fullWidth
            sx={{ fontFamily: 'Vazir', mb: 2,mt:2, direction: 'rtl', textAlign: 'right' }}
            InputProps={{ style: { fontFamily: 'Vazir', direction: 'rtl', textAlign: 'right' } }}
            disabled={!!editPage}
            helperText={editPage ? "آدرس صفحه قابل تغییر نیست" : "مثال: about-us, contact, terms"}
          />
          <TextField
            label="عنوان (meta_title)"
            value={form.meta_title}
            onChange={e => setForm(f => ({ ...f, meta_title: e.target.value }))}
            fullWidth
            sx={{ fontFamily: 'Vazir', mb: 2, direction: 'rtl', textAlign: 'right' }}
            InputProps={{ style: { fontFamily: 'Vazir', direction: 'rtl', textAlign: 'right' } }}
          />
          <TextField
            label="توضیحات سئو (meta_description)"
            value={form.meta_description}
            onChange={e => setForm(f => ({ ...f, meta_description: e.target.value }))}
            fullWidth
            sx={{ fontFamily: 'Vazir', mb: 2, direction: 'rtl', textAlign: 'right' }}
            InputProps={{ style: { fontFamily: 'Vazir', direction: 'rtl', textAlign: 'right' } }}
          />
          <TextField
            label="کلمات کلیدی سئو (meta_keywords)"
            value={form.meta_keywords}
            onChange={e => setForm(f => ({ ...f, meta_keywords: e.target.value }))}
            fullWidth
            sx={{ fontFamily: 'Vazir', mb: 2, direction: 'rtl', textAlign: 'right' }}
            InputProps={{ style: { fontFamily: 'Vazir', direction: 'rtl', textAlign: 'right' } }}
          />
        </DialogContent>
        <DialogActions sx={{ direction: 'rtl', justifyContent: 'flex-start', px: 3 }}>
          <Button onClick={() => setModalOpen(false)} color="secondary" variant="outlined" sx={{ fontFamily: 'Vazir', minWidth: 100, ml: 2 }}>انصراف</Button>
          <Button onClick={handleSave} color="primary" variant="contained" sx={{ fontFamily: 'Vazir', minWidth: 100 }} disabled={saving}>
            {saving ? 'در حال ذخیره...' : (editPage ? 'ذخیره تغییرات' : 'افزودن')}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default CustomPages; 